import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OfferHelper } from './helpers/offer.helper';
import { OfferSettingService } from './services';
import {
  OfferEffects,
  OfferLocationsEffects,
  OfferTermsEffects,
  reducers,
} from './store';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      OfferEffects,
      OfferLocationsEffects,
      OfferTermsEffects,
    ]),
    StoreModule.forFeature('offer', reducers),
  ],
  providers: [OfferHelper, OfferSettingService],
})
export class OfferModule {}
